import { Flex, Text } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { RiListUnordered, RiMapPinLine, RiUser3Line, RiMoreFill } from "@remixicon/react";
import { useTranslation } from "react-i18next";
import { MdOndemandVideo } from "react-icons/md";

import { MAIN_COLOR } from "../util/theme";

interface NavItemsProps {
  direction: "row" | "column";
  iconSize?: number;
  fontSize?: string;
  textOnly?: boolean;
}

const NavItems: React.FC<NavItemsProps> = ({
  direction,
  iconSize = 24,
  fontSize = "sm",
  textOnly = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const getLinkColor = (path: string) => {
    return location.pathname === path ? MAIN_COLOR : "black";
  };

  const getLinkColorIcon = (path: string) => {
    return location.pathname === path ? MAIN_COLOR : "black";
  };

  return (
    <Flex direction={direction} justify="space-between" gap={direction === "row" ? 8 : 0}>
      {/* List Item */}
      <Flex
        flex={direction === "column" ? "1" : "none"}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap="2px"
        cursor="pointer"
        onClick={() => navigate("/")}
      >
        {!textOnly && <RiListUnordered color={getLinkColorIcon("/")} size={iconSize} />}
        <Text fontSize={fontSize} color={getLinkColor("/")} fontWeight={600} textAlign="center">
          {t("list")}
        </Text>
      </Flex>

      {/* Map Item */}
      <Flex
        flex={direction === "column" ? "1" : "none"}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap="2px"
        cursor="pointer"
        onClick={() => navigate("/map")}
      >
        {!textOnly && <RiMapPinLine color={getLinkColorIcon("/map")} size={iconSize} />}
        <Text fontSize={fontSize} color={getLinkColor("/map")} fontWeight={600} textAlign="center">
          {t("map")}
        </Text>
      </Flex>

      {/* Profile Item */}
      <Flex
        flex={direction === "column" ? "1" : "none"}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap="2px"
        cursor="pointer"
        onClick={() => navigate("/profile")}
      >
        {!textOnly && <RiUser3Line color={getLinkColorIcon("/profile")} size={iconSize} />}
        <Text fontSize={fontSize} color={getLinkColor("/profile")} fontWeight={600} textAlign="center">
          {t("profile")}
        </Text>
      </Flex>

      {/* Music / Content Item */}
      <Flex
        flex={direction === "column" ? "1" : "none"}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap="2px"
        cursor="pointer"
        onClick={() => navigate("/content")}
      >
        {!textOnly && <MdOndemandVideo color={getLinkColorIcon("/content")} size={iconSize} />}
        <Text fontSize={fontSize} color={getLinkColor("/content")} fontWeight={600} textAlign="center">
          {t("content")}
        </Text>
      </Flex>
    </Flex>
  );
};

export default NavItems;